module.exports = __webpack_public_path__ + "static/media/fi-rs-pencil.44b10a01.png";